import apiSlice from "./api/api";
import { LEAVES, PROMOTIONS, RESIGNATIONS, TERMINATIONS, TRANSFERS } from "./ENDPOINTS";

const hrApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get terminations
    getTerminations: builder.query({
        query: ({page, search}) => ({
        url: `${TERMINATIONS}?page=${page}&q=${search}`,
        method: "GET",
        }),
        providesTags: ["Terminations"],
    }),
    // fetch employees
    saveTermination: builder.mutation({
      query: (data) => ({
        url: TERMINATIONS,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Terminations"],
    }),
    // get resignation
    getResignation: builder.query({
      query: ({page, search}) => ({
      url: `${RESIGNATIONS}?page=${page}&q=${search}`,
      method: "GET",
      }),
      providesTags: ["Resignations"],
    }),
    // save resignation
    saveResignation: builder.mutation({
      query: (data) => ({
        url: RESIGNATIONS,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Resignations"],
    }),
    // get promotions
    getPromotions: builder.query({
      query: ({page, search}) => ({
      url: `${PROMOTIONS}?page=${page}&q=${search}`,
      method: "GET",
      }),
      providesTags: ["Promotions"],
    }),
    // save promotion
    savePromotion: builder.mutation({
      query: (data) => ({
        url: PROMOTIONS,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Promotions"],
    }),
    // get transfers
    getTransfers: builder.query({
      query: ({page, search}) => ({
      url: `${TRANSFERS}?page=${page}&q=${search}`,
      method: "GET",
      }),
      providesTags: ["Transfers"],
    }),
    // save transfers
    saveTransfer: builder.mutation({
      query: (data) => ({
        url: TRANSFERS,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Transfers"],
    }),

     // get leaves
     getLeaves: builder.query({
      query: ({filter}) => {
        const params = new URLSearchParams();
        if (filter?.employee_id) params.append('employee_id', filter.employee_id);
        if (filter?.status) params.append('status', filter.status);
        if (filter?.department_id) params.append('department_id', filter.department_id);
        if (filter?.start_date) params.append('start_date', filter.start_date);
        if (filter?.end_date) params.append('end_date', filter.end_date);
        if (filter?.year) params.append('year', filter.year);

        return {
          url: `${LEAVES}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Leaves"],
    }),
    // save/create leave
    saveLeaves: builder.mutation({
      query: (data) => ({
        url: LEAVES,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Leaves"],
    }),
    // update leave
    updateLeave: builder.mutation({
      query: ({id, data}) => ({
        url: `${LEAVES}/${id}`,
        method: "PUT",
        body: data
      }),
      invalidatesTags: ["Leaves"],
    }),
    // approve leave
    approveLeave: builder.mutation({
      query: ({id, data}) => ({
        url: `${LEAVES}/${id}/approve`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Leaves"],
    }),
    // reject leave
    rejectLeave: builder.mutation({
      query: ({id, data}) => ({
        url: `${LEAVES}/${id}/reject`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Leaves"],
    }),
    // cancel leave
    cancelLeave: builder.mutation({
      query: ({id, data}) => ({
        url: `${LEAVES}/${id}/cancel`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Leaves"],
    }),
    // delete leave
    deleteLeave: builder.mutation({
      query: (id) => ({
        url: `${LEAVES}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Leaves"],
    }),
    
  })
});

export const {
    useLazyGetLeavesQuery,
    useSaveLeavesMutation,
    useUpdateLeaveMutation,
    useApproveLeaveMutation,
    useRejectLeaveMutation,
    useCancelLeaveMutation,
    useDeleteLeaveMutation,
    useLazyGetTransfersQuery,
    useSaveTransferMutation,
    useLazyGetPromotionsQuery,
    useSavePromotionMutation,
    useLazyGetTerminationsQuery,
    useSaveTerminationMutation,
    useSaveResignationMutation,
    useLazyGetResignationQuery
  } = hrApiSlice;